import * as React from 'react';
import { IconButton } from '..';

interface Props {
  page: number;
  lastPage: boolean;
  handleUpdate: (page: number) => void;
}

export default class Pagination extends React.Component<Props> {
  render() {
    return (
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <small className="has-text-grey">Page {this.props.page + 1}</small>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="buttons has-addons">
              <IconButton
                icon="chevron-left"
                className={this.props.page > 0 ? 'is-default' : 'is-static'}
                handleClick={() => {
                  if (this.props.page > 0) {
                    this.props.handleUpdate(this.props.page - 1);
                  }
                }}
              >
                Prev
              </IconButton>
              <IconButton
                icon="chevron-right"
                className={this.props.lastPage ? 'is-static' : 'is-default'}
                isRight
                handleClick={() => {
                  if (!this.props.lastPage) {
                    this.props.handleUpdate(this.props.page + 1);
                  }
                }}
              >
                Next
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
